export default __webpack_public_path__ + "static/media/vivriti3x.02b88be6.png";